export default __webpack_public_path__ + "images/98000128869ed919c62979c654eac865.svg";